import { useRef } from "react";

let pointerPos = [0,0];

const selectCaixa = (ev, props, lastClickTimeRef, onDoubleClick) => {
    const isClick = (ev.clientX - pointerPos[0])**2 + (ev.clientY - pointerPos[1])**2 < 25*25;
    if (!isClick) return;

    if (props.mode === 'paint') {
        if (props.shouldSetCaixaSelected !== false) props.setCaixaSelected(props.id);
        return;
    }

    const now = Date.now();
    const timeSinceLastClick = now - (lastClickTimeRef.current || 0);

    if (timeSinceLastClick < 400 && onDoubleClick) {
        // Double click detected
        onDoubleClick();
        lastClickTimeRef.current = 0;
        return;
    }

    lastClickTimeRef.current = now;

    if (props.shouldSetCaixaSelected !== false) props.setCaixaSelected(props.id);

    if (ev.shiftKey) {
        props.setSelectedIds(prev => {
            if (prev.includes(props.id)) {
                return prev.filter(id => id !== props.id);
            } else {
                return [...prev, props.id];
            }
        });
    } else {
        props.setSelectedIds([props.id]);
    }
};

const getConfirmatClass = casteller => {
    const assistencia = casteller["assistència"];
    if (parseInt(assistencia) === 2) return "fitxat";
    else if (parseInt(assistencia) === 1) return "ve";
    else if (parseInt(assistencia) === 0) return "no-ve";
    else return "no-sap-si-ve";
};

function SelectableCaixa(props) {
    const { submode, mode, setPosition, children, followPosition, setFollowPosition, disabled, selected, panzoom, json, setJsonOutput, readonly, arribenTard, surtenAviat, handleDragStart, onDoubleClick } = props;
    const lastClickTimeRef = useRef(0);

    const pointBegin = ev => {
        pointerPos = [ev.clientX, ev.clientY];
        // Start drag in transform mode
        if (mode === 'transform' && handleDragStart) {
            handleDragStart(ev, props.id);
        }
    };
    const pointFinish = ev => selectCaixa(ev, props, lastClickTimeRef, onDoubleClick);

    return (
        <div
            className={`selectable ${disabled ? 'disabled' : ''} ${(mode !== 'cordons' && mode !== 'paint' || submode === null) && (selected || props.selectedIds?.includes(props.id)) ? 'selected' : ''}`}
            style={{
                cursor: mode === 'paint'
                    ? 'crosshair'
                    : mode === 'transform' ? 'move' : 'pointer'
            }}

            onPointerDown={pointBegin}
            onPointerUp={pointFinish}
        >
            {children}
        </div>
    );
}

export default SelectableCaixa;
